// 通用方法，判断是否为有数据的数组
export const isDataArray = (data: any) => {
  if (Array.isArray(data) && data?.length > 0) return true;
  return false;
};

// 通用方法，判断两个字符串数组是否相等，忽略顺序
export const isEqualStringArray = (arrA: string[], arrB: string[]) => {
  if (!Array.isArray(arrA) || !Array.isArray(arrA)) return false;
  if (arrA?.length !== arrB?.length) return false;
  return new Set([...arrA, ...arrB]).size === arrA.length;
};
